import { Component } from '@angular/core';
import { TooltipPosition } from '@app/shared/enums';

@Component({
  selector: 'app-reusable-tooltip',
  templateUrl: './reusable-tooltip.component.html',
  styleUrls: ['./reusable-tooltip.component.scss'],
})
export class ReusableTooltipComponent {
  position: TooltipPosition = TooltipPosition.DEFAULT;
  text: string = '';
  left: string = '';
  top: string = '';
  visible: boolean = false;
  width: string = '';
}
